document.addEventListener("DOMContentLoaded", function() {
    console.log("Script is running...");

    // Wait for DOM to load and then use a timeout for dynamic content loading
    setTimeout(function() {
        var sealContainers = document.querySelectorAll("[class*='seal-subscriptions-lis']"); // NodeList
        console.log(sealContainers);

        // Loop through each matching element
        sealContainers.forEach(function(sealContainer) {
            if (sealContainer) {
                var customLink = document.createElement("a");
                customLink.href = "/a/subscriptions/login";
                customLink.className = "custom-link";
                customLink.textContent = "Click Here for More Details";

                // Append the link below the seal-container
                sealContainer.insertAdjacentElement("afterend", customLink);
                console.log("Custom link added for:", sealContainer);
            }
        });
    }, 500); // Timeout for 500ms to account for dynamic content
});

// document.addEventListener("DOMContentLoaded", function () {
    
//     var interval = setInterval(function () {
//         var sealContainer = document.querySelectorAll("[class*='seal-subscriptions-lis']");
//         if (sealContainer) {
//             console.log("Element found:", sealContainer);

//             var customLink = document.createElement("a");
//             customLink.href = "/custom-link";
//             customLink.className = "custom-link";
//             customLink.textContent = "Click Here for More Details";

//             sealContainer.insertAdjacentElement("afterend", customLink);
            
//             // Add your custom code here
//             clearInterval(interval); // Stop checking
//         } else {
//             console.log("Element not found yet...");
//         }
//     }, 500); // Check every 500ms
// });